import { Component, NgModule, OnInit } from '@angular/core';
import { ToastService } from 'src/app/core/toast.service';
import { ApiGruposopcionaisService } from 'src/app/dao/api-gruposopcionais.service';
import { GruposOpcional } from 'src/app/model/gruposopcionais';
import {ConfirmationService, MessageService} from 'primeng/api';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalService } from 'src/app/dao/global.service';
import { ProdutoapiService } from 'src/app/dao/api_produto.service';
import { CategoriaApiService } from 'src/app/dao/api_categoria.service';
import { FormsModule } from '@angular/forms';
import { MultiSelectModule } from 'primeng/multiselect';


@Component({
  selector: 'app-opcionaisporproduto',
  templateUrl: './opcionaisporproduto.page.html',
  styleUrls: ['./opcionaisporproduto.page.scss'],
  providers: [MessageService, ConfirmationService]
})

@NgModule({
  imports: [
    FormsModule,
    MultiSelectModule
  ],
})
  
export class OpcionaisporprodutoPage implements OnInit {
  opcionalDialog: boolean;
  duplicarDialog: boolean;


  grupoOrigem;
  grupoDestino;


  opcionais: GruposOpcional[];

  opcional: GruposOpcional;

  opcional2: GruposOpcional[];

  selectedopcionais: GruposOpcional[];

  categoriasNomesAux = [];

  unselectedCountries2 = [];

  submitted: boolean;

  selectedCountries2 = [];

  grupos = [];

  carregando = false;

  opcionais2 = [];


  fileToUpload: File = null;
  imgPath;
  dominio;
  caminhoImgCampo;

  countries2: any[];

  categorias = [];

  clonedProducts: { [s: string]: GruposOpcional; } = {};

  // tslint:disable-next-line: max-line-length
  constructor(private apiOpcs: ApiGruposopcionaisService, private http: HttpClient, private global: GlobalService, private opcionaiservice: ApiGruposopcionaisService, private toast: ToastService, private confirmationService: ConfirmationService, private apiproduto: ProdutoapiService, private categoriaApi : CategoriaApiService) { }

  ngOnInit() {
    this.dominio = this.global.dominio;
    this.opcional = new GruposOpcional();
    this.loadCats();
    this.getGrupos();
    this.getProdutos();
    this.loadOpcs();
    
    
    

  }

  openNew() {
    // tslint:disable-next-line: new-parens
    this.opcional = {};
    this.submitted = false;
    this.opcionalDialog = true;
  }

  
  openNew2() {;
    this.duplicarDialog = true;
  }


  async salvarOpc(opcional){
    const produtosParaExcluir = [];
    const produtosParaIncluir = [];
try {
  
    // Verificar produtos que precisam ser excluídos
    for (const produto of opcional.produtos) {
      if (!opcional.produtosSelecionados.some(produtoSelecionado => produtoSelecionado.code === produto.code)) {
          produtosParaExcluir.push(produto);
      }
  }

  // Verificar produtos que precisam ser incluídos
  for (const produtoSelecionado of opcional.produtosSelecionados) {
      if (!opcional.produtos.some(produto => produto.code === produtoSelecionado.code)) {
          produtosParaIncluir.push(produtoSelecionado);
      }
  }

    console.log(produtosParaExcluir);
    console.log(produtosParaIncluir);
    console.log(opcional.id);

for (let index = 0; index < produtosParaExcluir.length; index++) {
  const element2 = produtosParaExcluir[index];
  const result3 = this.opcionaiservice.excluirLigacao(opcional.id, element2.id);
}


for (let index = 0; index < produtosParaIncluir.length; index++) {
  const element3 = produtosParaIncluir[index];
  const result1 = await this.opcionaiservice.insertLigacaco2(element3.code, opcional.id);
}

opcional.produtos = produtosParaIncluir;
this.toast.showSucess('Salvo com sucesso!');
} catch (error) {
  this.toast.showError('Erro ao salvar!');
}



  }

  async loadCats() {
    this.categorias = await this.categoriaApi.listarTodas();
  }



  marcarLinhaCheckbox(opcional: any) {
    // Inicializa o array de selecionados se estiver vazio
    this.selectedopcionais = this.selectedopcionais || [];
  
    // Verifica se o item já está selecionado
    const index = this.selectedopcionais.indexOf(opcional);
  
    if (index > -1) {
      // Remove o item se já estiver selecionado
      this.selectedopcionais.splice(index, 1);
    } else {
      // Adiciona o item e desmarca os outros (seleção única)
      this.selectedopcionais = [opcional];
    }
  }

  async loadOpcs() {
    this.opcionais = await this.opcionaiservice.listarTodasEprodutos();

    for (let index = 0; index < this.opcionais.length; index++) {
        const element = this.opcionais[index];

        if (element.produtos.length > 0) {
            const opcAux2 = element.produtos.map(c => {
                const categoriaId = parseInt(c['categoria']);
                console.log(c['categoria']);
                const categoria = this.categorias.find(cat => cat.id === categoriaId);
                const categoriaNome = categoria ? categoria.nome : 'Categoria não encontrada';
                return ({ nome: c['nome'] + '  CAT:' + categoriaNome, code: parseInt(c['id']) });
            });
            element.produtosSelecionados = opcAux2;
        } else {
            element.produtosSelecionados = [];
        }
    }


    


    
    this.categoriasNomesAux =  await this.apiOpcs.listarTodosNomes()
    .catch(err => {
      console.error('Erro ao obter Opcionais', err);
      this.toast.showError('Erro ao obter Opcionais');
    });
    
       
    this.opcionais = this.opcionais.map(item => {
      const encontrada = this.categoriasNomesAux.find(g => g.grupo === item.grupo);
      return {
        ...item,
        nomeGrupo: encontrada ? encontrada.nome : item.grupo
      };
    });

    console.log(this.opcionais);
}



getProdutos() {
  return this.apiproduto.listarTodas()
    .then(opcionais2 => {
      this.countries2 = opcionais2.map(c => {
        const categoriaId = parseInt(c.categoria.id);
        const categoria = this.categorias.find(cat => cat.id === categoriaId);
        const categoriaNome = categoria ? categoria.nome : 'Categoria não encontrada';
        return ({ nome: c.nome + '  CAT:' + categoriaNome, code: parseInt(c.id) });
      });

      console.log(this.countries2);
    })
    .catch(erro => {
      this.toast.showError('Erro ao carregar Opcionais!');
    });
}

  deleteSelectedopcionais() {
    this.confirmationService.confirm({
      message: 'Deseja mesmo deletar os opcionais selecionados?',
      header: 'Confirmar',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.opcionais = this.opcionais.filter(val => !this.selectedopcionais.includes(val));
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this.selectedopcionais.length; i++) {
          const result = this.opcionaiservice.excluir(this.selectedopcionais[i].id);
        }
        this.selectedopcionais = null;
        //this.toast.showSucess('Opcionais Excluídos com Sucesso!');
      }
    });
  }



  confirmarCopiarOpcs() {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja copiar o grupo '+this.grupoOrigem+' para o grupo '+this.grupoDestino+'',
      header: 'Confirmar',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.saveDuplicar();
      }
    });
  }

  editopcional(opcional: GruposOpcional) {
    this.opcional = {...opcional};
    this.opcionalDialog = true;
  }

  deleteopcional(opcional: GruposOpcional) {
    this.confirmationService.confirm({
      message: 'Deseja mesmo deletar o Opcional ' + opcional.nome + '?',
      header: 'Confirmar',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        const result = this.opcionaiservice.excluir(opcional.id);
        this.opcionais = this.opcionais.filter(val => val.id !== opcional.id);
        this.opcional = {};
        this.toast.showSucess('Opcional Excluído com Sucesso!');
      }
    });
  }

  hideDialog() {
    this.opcionalDialog = false;
    this.submitted = false;
    this.caminhoImgCampo = null; // Limpar o campo de entrada de arquivo
  }

  
  hideDialog2() {
    this.duplicarDialog = false;
  }


  
  onRowEditInit(opcional: GruposOpcional) {
    this.clonedProducts[opcional.id] = { ...opcional };
  }

  async onRowEditSave(opcional: GruposOpcional) {
   let opcionaisDoGrupo = await this.opcionaiservice.getByGrupo(opcional.grupo);
   for (let index = 0; index < opcionaisDoGrupo.length; index++) {
    const element = opcionaisDoGrupo[index];
    if(opcional.posicao == element.posicao && opcional.id != element.id){
      this.toast.showError('Erro ao editar, posição já ocupada!');
      this.opcionaiservice.listarTodas().then(data => this.opcionais = data);

      return;
    }
   }
      delete this.clonedProducts[opcional.id];
      try {
        this.opcionaiservice.atualizar(opcional);
        this.toast.showSucess('Editado com Sucesso!');
      } catch (error) {
        this.toast.showError('Erro ao editar!');
        this.opcionaiservice.listarTodas().then(data => this.opcionais = data);
      }

  }

  onRowEditCancel(opcional: GruposOpcional, index: number) {
    this.opcionais[index] = this.clonedProducts[opcional.id];
    delete this.opcionais[opcional.id];
    this.opcionaiservice.listarTodas().then(data => this.opcionais = data);
  }

  getGrupos() {

        let gruposAux = [
      {name: 'Grupo 1', code: 'grupo1'},
      {name: 'Grupo 2', code: 'grupo2'},
      {name: 'Grupo 3', code: 'grupo3'},
      {name: 'Grupo 4', code: 'grupo4'},

      {name: 'Bordas', code: 'borda'},
      {name: 'Massas', code: 'massa'},
      {name: 'Bebidas', code: 'bebida'},

      {name: 'Misturas', code: 'misturas'},

      {name: 'Grupo Extra', code: 'grupoExtra'},
      
      {name: 'Grupo 5', code: 'grupo5'},
      {name: 'Grupo 6', code: 'grupo6'},
      {name: 'Grupo 7', code: 'grupo7'},
      {name: 'Grupo 8', code: 'grupo8'},
      {name: 'Grupo 9', code: 'grupo9'},
      {name: 'Grupo 10', code: 'grupo10'},
      {name: 'Grupo 11', code: 'grupo11'},
      {name: 'Grupo 12', code: 'grupo12'},
      {name: 'Grupo 13', code: 'grupo13'},
      {name: 'Grupo 14', code: 'grupo14'},
      {name: 'Grupo 15', code: 'grupo15'},
      {name: 'Grupo 16', code: 'grupo16'},
      {name: 'Grupo 17', code: 'grupo17'},
      {name: 'Grupo 18', code: 'grupo18'},
      {name: 'Grupo 19', code: 'grupo19'},
      {name: 'Grupo 20', code: 'grupo20'},
      {name: 'Grupo 21', code: 'grupo21'},
      {name: 'Grupo 22', code: 'grupo22'},
      {name: 'Grupo 23', code: 'grupo23'},
      {name: 'Grupo 24', code: 'grupo24'},
      {name: 'Grupo 25', code: 'grupo25'},
  ];

  }


 async saveopcional() {
    this.submitted = true;
    if (this.opcional.nome.trim()) {
      if (this.opcional.id) {
        this.opcionais[this.findIndexById(this.opcional.id)] = this.opcional;
        this.opcional.nome = this.opcional.nome.replace(/(&)/g,'e');
        this.opcional.nome = this.opcional.nome.replace(/(\s)/g,'_');



        let opcionaisDoGrupo = await this.opcionaiservice.getByGrupo(this.opcional.grupo);
        for (let index = 0; index < opcionaisDoGrupo.length; index++) {
         const element = opcionaisDoGrupo[index];
         if(this.opcional.posicao == element.posicao && this.opcional.id != element.id){
           this.toast.showError('Erro ao editar, posição já ocupada!');
           this.opcionaiservice.listarTodas().then(data => this.opcionais = data);
           return;
         }
        }




        //replace(/(\\|\/|\s)/g,'_');
        this.opcionaiservice.atualizar(this.opcional);
        this.toast.showSucess('Opcional Atualizado com Sucesso!');
      } else {
        // tslint:disable-next-line: radix
        this.opcional.nome = this.opcional.nome.replace(/(&)/g,'e');
        this.opcional.nome = this.opcional.nome.replace(/(\s)/g,'_');

        let opcionaisDoGrupo = await this.opcionaiservice.getByGrupo(this.opcional.grupo);
        for (let index = 0; index < opcionaisDoGrupo.length; index++) {
         const element = opcionaisDoGrupo[index];
         if(this.opcional.posicao == element.posicao && this.opcional.id != element.id){
           this.toast.showError('Erro ao salvar, posição já ocupada!');
           this.opcionaiservice.listarTodas().then(data => this.opcionais = data);
           return;
         }
        }

        const result = await this.opcionaiservice.adicionar(this.opcional);
        this.opcionais.push(result);
        this.toast.showSucess('Opcional Cadastrado com Sucesso!');
      }

      this.opcionais = [...this.opcionais];
      this.opcionalDialog = false;
      this.opcional = {};
    }
    this.caminhoImgCampo = null; // Limpar o campo de entrada de arquivo
  }






  async saveDuplicar() {

    if(this.grupoOrigem == undefined || this.grupoDestino == undefined){
      this.toast.showError("Selecione os dois grupos!");
      return;
    }
    if(this.grupoOrigem == this.grupoDestino){
      this.toast.showError("Selecione dois grupos diferentes!");
      return;
    }

    let opsDestino = await this.opcionaiservice.getByGrupo(this.grupoDestino);
    console.log(opsDestino);

    if(opsDestino.length > 0){
      this.toast.showError("O Grupo de Destino precisa estar vazio para completar a requisição!");
      return;
    }

    this.carregando = true;

    let opsOrigem = await this.opcionaiservice.getByGrupo(this.grupoOrigem);

    for (let index = 0; index < opsOrigem.length; index++) {
      const element = opsOrigem[index];
      
      this.opcional.nome = element.nome;
      this.opcional.grupo = this.grupoDestino;
      this.opcional.valor = element.valor;
      this.opcional.quantidade = element.quantidade;
      this.opcional.img = element.img;
      this.opcional.posicao = element.posicao;

      const result = await this.opcionaiservice.adicionar(this.opcional);
      console.log(result);
      //this.opcionais.push(result);
      
    }
    this.toast.showSucess('Opcionais Duplicados com Sucesso!');
    this.duplicarDialog = false;
    this.grupoDestino = "";
    this.grupoOrigem = "";

    this.opcionaiservice.listarTodas().then(data => this.opcionais = data);
    this.carregando = false;
  }



  postMethod(files: FileList): void {
    this.fileToUpload = files.item(0);

    this.compressImage(this.fileToUpload).then((compressedFile: File) => {
      let formData = new FormData();
      formData.append('file', compressedFile, compressedFile.name);
      
      let headers = new HttpHeaders();
      const auth = btoa(this.global.user + ':' + this.global.pass);
      headers = headers.set('Authorization', 'Basic ' + auth);

      this.http.post(this.dominio + '/backend/api/v2/gruposopcionais/getImg', formData, { headers })
        .subscribe((val) => {
          this.imgPath = val;
          this.opcional.img = this.imgPath;
        });
    });
  }


  compressImage(file: File): Promise<File> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const img = new Image();
        img.src = reader.result as string;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
  
          const maxWidth = 800;
          const maxHeight = 600;
          let width = img.width;
          let height = img.height;
  
          // Reduzindo em 25%
          width *= 0.75;
          height *= 0.75;
  
          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }
  
          if (height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
          }
  
          canvas.width = width;
          canvas.height = height;
  
          ctx.drawImage(img, 0, 0, width, height);
  
          canvas.toBlob((blob) => {
            const compressedFile = new File([blob], file.name, {
              type: 'image/jpeg',
              lastModified: Date.now()
            });
            resolve(compressedFile);
          }, 'image/jpeg', 0.7);
        };
      };
      reader.onerror = (error) => reject(error);
    });
  }


  limpaImg() {
    this.opcional.img = '';
    let headers = new HttpHeaders();
    const auth = btoa(this.global.user + ':' + this.global.pass);
    headers = headers.set('Authorization', 'Basic ' + auth);
    const body = JSON.stringify(this.opcional);
    // tslint:disable-next-line: max-line-length
    this.http.post(this.dominio + '/backend/api/v2/gruposopcionais/limpaImg', body, { headers }).subscribe((val) => {
    });
    return false;
  }

  findIndexById(id: number): number {
    let index = -1;
    for (let i = 0; i < this.opcionais.length; i++) {
      if (this.opcionais[i].id === id) {
        index = i;
        break;
      }
    }

    return index;
  }
}
